module.exports = __webpack_public_path__ + "img/14.721d9665.svg";